<template>
  <div class="fixed-inner-label" data-cy="form-label">
    <slot :id="key.id" data-cy="form-label-slot">DEFAULT SLOT</slot>
    <label :for="key.id.toString()" data-cy="form-label-text">{{ text }}</label>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

defineProps({
  text: {
    type: String,
    default: ""
  }
})

const key = ref({ id: Math.ceil(Math.random() * 10000) });
</script>
